import * as React from 'react'

export interface BookingShape {
  id: number
  user_username: string
  start_time: string // ISO 8601 string
  end_time: string // ISO 8601 string
  phone: string
  car_registration: string
}

interface BookingBlockProps {
  booking: BookingShape
  style: React.CSSProperties
}

const BookingBlock: React.FC<BookingBlockProps> = ({ booking, style }) => {
  const startTimeFormatted = new Date(booking.start_time).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })
  const endTimeFormatted = new Date(booking.end_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })

  return (
    <div
      key={booking.id}
      className="booking-block pl-2 pr-2"
      style={style}
      title={`${booking.user_username} (${startTimeFormatted} - ${endTimeFormatted})`}
    >
      <span className="booking-user">
        {booking.user_username} - {booking.car_registration}
        {` (${startTimeFormatted} - ${endTimeFormatted})`}
      </span>
    </div>
  )
}

export default BookingBlock
